export enum RegistrationSystem {
    Default = 0,
    PosApp = 1,
    BankingApp = 2,
    SalesPortal = 3,
    VivaCom = 4,
    Marketplace = 5
}
